import { Component, Input } from '@angular/core';
import { PipelineCardVm } from '../../../../domain/model/pipeline-health.model';

/** One derived-rate card: title, the rate, its `n of N` pair and a mini progress bar. */
@Component({
  selector: 'ifbp-pipeline-metric-card',
  templateUrl: './pipeline-metric-card.component.html',
  styleUrls: ['./pipeline-metric-card.component.scss'],
  standalone: false,
})
export class PipelineMetricCardComponent {
  @Input() vm: PipelineCardVm;
}
